import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import BaseDialog from "../utils/dialog/BaseDialog";

const PostRolloverReminderDialog = ({
  open,
  onClose,
  hasHirePurchaseSchedule,
  onOpenHirePurchase,
}) => (
  <BaseDialog
    open={open}
    onClose={onClose}
    maxWidth='md'
    title='Rollover completed'
    subtitle='Review the carried-forward data before continuing your computation.'
    icon={<CheckCircleOutlineIcon />}
    iconColor='success.main'
    paperSx={{ maxWidth: 780 }}
    contentSx={{ px: { xs: 2, sm: 3 } }}
    actionsSx={{
      flexDirection: { xs: "column-reverse", sm: "row" },
      alignItems: { xs: "stretch", sm: "center" },
      gap: 1,
      "& > :not(style) ~ :not(style)": { ml: 0 },
    }}
    actions={
      <>
        <Button
          onClick={onClose}
          color='inherit'
          sx={{
            mr: { xs: 0, sm: "auto" },
            color: "text.secondary",
            textTransform: "none",
          }}
        >
          I'll Check Later
        </Button>
        {hasHirePurchaseSchedule && (
          <Button
            variant='contained'
            startIcon={<OpenInNewIcon />}
            onClick={onOpenHirePurchase}
            sx={{ textTransform: "none" }}
          >
            Open Hire Purchase Schedule
          </Button>
        )}
      </>
    }
  >
    <Stack spacing={2.5}>
      <Paper
        variant='outlined'
        sx={{ p: 2, borderRadius: 2, bgcolor: "action.hover" }}
      >
        <Typography variant='subtitle2' fontWeight={600} sx={{ mb: 0.5 }}>
          Review and save your data
        </Typography>
        <Typography
          variant='body2'
          color='text.secondary'
          sx={{ lineHeight: 1.7 }}
        >
          The rollover has completed successfully. Review and save all
          rolled-over balances and schedules to ensure the data is correct.
        </Typography>
      </Paper>
      <Box>
        <Typography variant='subtitle1' fontWeight={600} sx={{ mb: 1 }}>
          Additional action for Hire Purchase
        </Typography>
        <Paper
          variant='outlined'
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: (theme) => alpha(theme.palette.warning.main, 0.04),
            borderColor: (theme) => alpha(theme.palette.warning.main, 0.25),
          }}
        >
          <Stack direction='row' spacing={1.5} alignItems='flex-start'>
            <WarningAmberIcon
              sx={{ color: "warning.main", fontSize: 20, mt: 0.25 }}
            />
            <Box>
              <Typography variant='subtitle2' fontWeight={600} sx={{ mb: 0.5 }}>
                Open and save the schedule again
              </Typography>
              <Typography
                variant='body2'
                color='text.secondary'
                sx={{ lineHeight: 1.7 }}
              >
                If you have a Hire Purchase Schedule, open and save it again to
                initialize the principal paid data. This is required for
                accurate calculations.
              </Typography>
            </Box>
          </Stack>
        </Paper>
      </Box>
    </Stack>
  </BaseDialog>
);

export default PostRolloverReminderDialog;
